export const QUESTION_CONTEXT_TYPES_ID_MAPPING = {
  TABBED: '5',
  TABULAR: '6'
}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/data/models/question-context-type/question-context-type-id.mapping.ts